<template>
  <span>
    <p v-if="badCreds" class="text-lg font-bold text-brand-red flex items-center space-x-2">
      <font-awesome-icon :icon="['fas', 'times-circle']" class="text-sm"></font-awesome-icon>
    </p>
    <p v-else-if="validCreds" class="text-lg font-bold text-green-700 flex items-center space-x-2">
      <font-awesome-icon :icon="['fas', 'check-circle']" class="text-sm"></font-awesome-icon>
    </p>
    <p v-else class="text-lg font-bold text-green-700 flex items-center space-x-2">
      <font-awesome-layers class="text-xl">
        <font-awesome-icon :icon="['fas', 'circle']" class="text-brand-medium-blue" />
        <font-awesome-icon :icon="['fas', 'plug']" class="text-xs text-brand-blue" :class="'text-brand-blue'" />
      </font-awesome-layers>
    </p>
  </span>
</template>

<script>
export default {
  name: 'PaddleStatus',
  props: {
    badCreds: {
      type: Boolean,
      required: true,
    },
    validCreds: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
